import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.article-header',
        print: '.article-header__icon--print',
    },
    classNames: {

    },
    dataAttributes: {

    },
};

class ArticleHeader {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;

    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListener();
    }



    _getDomElements() {
        return {
            $print: this._$rootElement.find(config.selectors.print),
        };
    }

    _addEventListener() {
        this._elements.$print.on('click', () => {
            window.print();
        });

        this._elements.$print.on('keydown', (e) => {
            if(e.keyCode !== 13) return;

            window.print();
        });
    }
}

moduleRegistry.registerModule('ArticleHeader', ArticleHeader);
moduleRegistry.autoApplyModule('ArticleHeader', config.selectors.root);
